<div class="container p-3" *ngIf="newPostView">
    <div class="row" [formGroup]="newMessageFormGroup">
        <div class="col">
            <div class="mb-3">
                <label for="newMessageTextArea">Message</label>
                <textarea #newMessageTextArea type="text" class="form-control" id="newMessageTextArea" placeholder="New message..." rows="3" formControlName="newMessageTextArea"></textarea>
            </div>
            <div class="mb-3">
                <label>Image</label>
                <div>
                    <input type="file" accept="image/*" class="form-control" id="newMessageFileInput" (change)="newMessageFileInputChange($event)" formControlName="newMessageFileInput">
                </div>
            </div>
            <div class="mb-3" [hidden]="!newMessageSelectedFile">
                <div class="row">
                    <div class="col">
                        <img id="imagePreview" [src]="imagePreviewDataURL" style="max-width: 100%;" width="480px" height="270px">
                    </div>
                    <div class="col">
                        <img id="imageCropped" [src]="imageCroppedDataURL" width="480px" height="270px">
                    </div>
                </div>
            </div>
            <div class="mb-3 row">
                <div class="col-auto">
                    <button class="btn btn-primary" [disabled]="newMessageFormGroup.invalid" (click)="postNewMessage()">
                        <i class="fas fa-plus-circle"></i> Post
                    </button>
                </div>
                <div class="col-auto">
                    <button class="btn btn-secondary" (click)="cancelNewMessage()">
                        <i class="fas fa-ban"></i> Cancel
                    </button>
                </div>
            </div>
        </div>
    </div>
</div>
<div class="container p-3" *ngIf="!newPostView">
    <div class="row">
        <div class="col position-relative">
            <div class="row gx-1" style="position: absolute; top: 0px; right: 15px;">
                <div class="col-auto">
                    <button class="btn btn-outline-primary" (click)="newPostView = true;">
                        <i class="fas fa-plus-circle"></i> New post
                    </button>
                </div>
                <div class="col-auto">
                    <button class="btn btn-primary" (click)="refresh()">
                        <i class="fas fa-sync-alt"></i> Refresh
                    </button>
                </div>
            </div>
            <div [formGroup]="filterFormGroup">
                <div class="float-start align-baseline me-3">
                    <h3>Filters</h3>
                </div>
                <div class="float-start align-baseline me-3 my-2 mb-3">
                    <label class="me-2">Deleted</label>
                    <div class="form-check form-check-inline me-2">
                        <input type="checkbox" class="form-check-input" id="deletedNoCheckbox" formControlName="deletedNoCheckbox">
                        <label class="form-check-label" for="deletedNoCheckbox">No</label>
                    </div>
                    <div class="form-check form-check-inline me-2">
                        <input type="checkbox" class="form-check-input" id="deletedYesCheckbox" formControlName="deletedYesCheckbox">
                        <label class="form-check-label" for="deletedYesCheckbox">Yes</label>
                    </div>
                </div>
                <div class="float-start align-baseline me-3 my-2 mb-3">
                    <label class="me-2">Inappropriate</label>
                    <div class="form-check form-check-inline me-2">
                        <input type="checkbox" class="form-check-input" id="inappropriateUndefinedCheckbox" formControlName="inappropriateUndefinedCheckbox">
                        <label class="form-check-label" for="inappropriateUndefinedCheckbox">―</label>
                    </div>
                    <div class="form-check form-check-inline me-2">
                        <input type="checkbox" class="form-check-input" id="inappropriateNoCheckbox" formControlName="inappropriateNoCheckbox">
                        <label class="form-check-label" for="inappropriateNoCheckbox">No</label>
                    </div>
                    <div class="form-check form-check-inline me-2">
                        <input type="checkbox" class="form-check-input" id="inappropriateYesCheckbox" formControlName="inappropriateYesCheckbox">
                        <label class="form-check-label" for="inappropriateYesCheckbox">Yes</label>
                    </div>
                </div>
            </div>
        </div>
    </div>
    <hr>
    <div class="row" *ngIf="filteredMessages.length > 0">
        <div class="col-12 col-sm-10 offset-sm-1 col-md-8 offset-md-2 col-lg-6 offset-lg-3">
            <div *ngFor="let message of filteredMessages">
                <community-message-card [message]="message" (commentClick)="modalMessage = message;" (photoClick)="modalPhoto = $event;" (updateUser)="updateUser($event)"></community-message-card>
                <hr>
            </div>
        </div>
    </div>
    <div class="row" *ngIf="count > 0">
        <div class="col-12 col-sm-10 offset-sm-1 col-md-8 offset-md-2 col-lg-6 offset-lg-3 text-center">
            <button class="btn btn-primary mx-auto" (click)="browseBefore()" [disabled]="browseBeforeInProgress" [class.progress-bar-striped]="browseBeforeInProgress" [class.progress-bar-animated]="browseBeforeInProgress">
                <div *ngIf="!browseBeforeInProgress">
                    <i class="fas fa-step-forward" style="transform: rotate(90deg)"></i> Next
                </div>
                <div *ngIf="browseBeforeInProgress">
                    <i class="fas fa-hourglass-half"></i> Loading
                </div>
            </button>
        </div>
    </div>
    <div id="modalMessage" class="modal" style="background-color: rgba(255, 255, 255, 0.75)" tabindex="-1" [style.display]="modalMessage ? 'block' : 'none'" (click)="modalMessage = null;">
        <div class="modal-dialog modal-dialog-scrollable modal-dialog-centered modal-lg">
            <div class="modal-content h-100" (click)="$event.stopPropagation()">
                <div class="modal-body">
                    <button type="button" class="btn-close position-fixed p-3" style="top: 0px; right: 0px;" (click)="modalMessage = null;"></button>
                    <community-modal [message]="modalMessage" (photoClick)="modalPhoto = $event;" (updateUser)="updateUser($event)"></community-modal>
                </div>
            </div>
        </div>
    </div>
    <div id="modalPhoto" class="modal text-center p-4" style="background-color: rgba(0, 0, 0, 0.25)" tabindex="-1" [style.display]="modalPhoto ? 'block' : 'none'" (click)="modalPhoto = null;">
        <img class="mw-100 mh-100" src="{{ modalPhoto }}" (click)="modalPhoto = null;">
    </div>
</div>